import axios from "axios";
import { showLoading } from "./../../../module/loading";
import { hideLoading } from "./../../../module/loading";
/**
 * シリーズ横断Connect提案依頼詳細画面の初期化
 */
export function initMyPageConnectDetail() {
    initOfferNoAnchor();
    initConnectOfferDownloadButton();
}
/**
 * 提案No並び替えaタグの初期化
 */
function initOfferNoAnchor() {
    const anchor = document.getElementById('my-page-connect-request-offer-no-sort-anchor');
    if (anchor === null)
        return;
    let asc = false;
    anchor.addEventListener("click", () => {
        asc = !asc;
        const table = document.getElementById('my-page-connect-request-table');
        const rows = table.rows;
        const n = rows.length;
        for (let i = n - 1; i > 1; i--) {
            for (let j = 1; j < i; j++) {
                const no1 = Number(rows[j].dataset.offerNo);
                const no2 = Number(rows[j + 1].dataset.offerNo);
                if (asc ? no1 > no2 : no1 < no2) {
                    rows[j].parentElement.insertBefore(rows[j + 1], rows[j]);
                }
            }
        }
    });
}
/**
 * Connect Offer資料をもらうボタンの初期化
 */
function initConnectOfferDownloadButton() {
    // const button = document.getElementById("connect-offer-download") as HTMLButtonElement;
    const buttons = document.querySelectorAll('[id^="connect-offer-download-"]');
    if (buttons === null)
        return;
    for (const button of buttons) {
        button.addEventListener("click", function () {
            const downloadInputId = "connect-webooth-download-checkbox-" + this.dataset.id + "-";
            const downloadInputs = document.querySelectorAll(`[id^=${downloadInputId}]`);
            for (const input of downloadInputs) {
                input.checked = false;
            }
            const downloadQuestionnaireTable = document.getElementById("download-questionnaire-table-" + this.dataset.id);
            const completeQuestionnaireTable = document.getElementById("complete-questionnaire-table-" + this.dataset.id);
            if (downloadQuestionnaireTable !== null && completeQuestionnaireTable !== null) {
                if (downloadQuestionnaireTable.hasAttribute("hidden")) {
                    completeQuestionnaireTable.setAttribute("hidden", "hidden");
                }
                const downloadInput1 = document.getElementById("download-questionnaire-input-" + this.dataset.id + "-1");
                const downloadInput2 = document.getElementById("download-questionnaire-input-" + this.dataset.id + "-2");
                const downloadInput3 = document.getElementById("download-questionnaire-input-" + this.dataset.id + "-3");
                const completeInput1 = document.getElementById("complete-questionnaire-input-" + this.dataset.id + "-1");
                const completeInput2 = document.getElementById("complete-questionnaire-input-" + this.dataset.id + "-2");
                const completeInput3 = document.getElementById("complete-questionnaire-input-" + this.dataset.id + "-3");
                if (downloadInput1 !== null) {
                    downloadInput1.value = "";
                }
                if (downloadInput2 !== null) {
                    downloadInput2.value = "";
                }
                if (downloadInput3 !== null) {
                    downloadInput3.value = "";
                }
                if (completeInput1 !== null) {
                    completeInput1.value = "";
                }
                if (completeInput2 !== null) {
                    completeInput2.value = "";
                }
                if (completeInput3 !== null) {
                    completeInput3.value = "";
                }
            }
            const downloadButton = document.getElementById("sample-series-webooth-download-button-" + this.dataset.id);
            downloadButton.disabled = true;
            const downloadMain = document.getElementById("sample-series-webooth-download-main-" + this.dataset.id);
            const completeMain = document.getElementById("sample-series-webooth-download-complete-main-" + this.dataset.id);
            downloadMain.style.display = "block";
            completeMain.style.display = "none";
            const modal = document.getElementById("sample-series-webooth-download-modal-" + this.dataset.id);
            initCheckboxes(this.dataset.id);
            initDownloadButton(this.dataset.id);
            modal.classList.add("is-show");
        });
    }
}
/**
 * チェックボックスの初期化
 */
function initCheckboxes(connectOfferId) {
    const inputId = "connect-webooth-download-checkbox-" + connectOfferId + "-";
    const inputs = document.querySelectorAll(`[id^=${inputId}]`);
    for (const input of inputs) {
        input.addEventListener("change", () => {
            let disabled = true;
            for (const input of inputs) {
                if (input.checked) {
                    disabled = false;
                }
            }
            const button = document.getElementById("sample-series-webooth-download-button-" + connectOfferId);
            button.disabled = disabled;
        });
    }
}
/**
 * 資料をもらうボタンの初期化
 */
function initDownloadButton(connectOfferId) {
    const inputId = "connect-webooth-download-checkbox-" + connectOfferId + "-";
    const button = document.getElementById("sample-series-webooth-download-button-" + connectOfferId);
    if (button === null)
        return;
    button.addEventListener("click", async () => {
        showLoading();
        const dict = {};
        const downloadInputs = document.querySelectorAll(`[id^=${inputId}]`);
        for (const input of downloadInputs) {
            dict[input.dataset.id] = input.checked;
        }
        const link = document.createElement("a");
        document.body.appendChild(link);
        for (const input of downloadInputs) {
            if (input.checked) {
                const url = input.dataset.url;
                const xhr = new XMLHttpRequest();
                xhr.open("GET", url, true);
                // Blobオブジェクトとしてダウンロードする
                xhr.responseType = "blob";
                xhr.onload = function () {
                    const blob = xhr.response;
                    const fileName = input.dataset.name;
                    const objUrl = window.URL.createObjectURL(blob);
                    const link = document.createElement("a");
                    link.href = objUrl;
                    link.download = fileName;
                    link.click();
                };
                // XMLHttpRequestオブジェクトの通信を開始する
                xhr.send();
            }
        }
        link.remove();
        const postData = {
            connect_offer_id: connectOfferId,
            document_ids: [],
            webooth_questionnaire_id: null,
            answers: {
                answer_1: null,
                answer_2: null,
                answer_3: null,
            },
        };
        const downloadQuestionnaireTable = document.getElementById("download-questionnaire-table-" + connectOfferId);
        const completeQuestionnaireTable = document.getElementById("complete-questionnaire-table-" + connectOfferId);
        if (downloadQuestionnaireTable !== null && completeQuestionnaireTable !== null) {
            const downloadInput1 = document.getElementById("download-questionnaire-input-" + connectOfferId + "-1");
            const downloadInput2 = document.getElementById("download-questionnaire-input-" + connectOfferId + "-2");
            const downloadInput3 = document.getElementById("download-questionnaire-input-" + connectOfferId + "-3");
            postData.webooth_questionnaire_id = downloadQuestionnaireTable.dataset.id;
            postData.answers.answer_1 = downloadInput1.value;
            postData.answers.answer_2 = downloadInput2.value;
            postData.answers.answer_3 = downloadInput3.value;
        }
        for (const input of downloadInputs) {
            if (input.checked) {
                postData.document_ids.push(input.dataset.id);
            }
        }
        try {
            const res = await axios.post("/u/portal/api/connectOffer/download", postData);
            if (postData.answers.answer_1 !== null || postData.answers.answer_2 !== null || postData.answers.answer_3 !== null) {
                const completeInput1 = document.getElementById("complete-questionnaire-input-" + connectOfferId + "-1");
                const completeInput2 = document.getElementById("complete-questionnaire-input-" + connectOfferId + "-2");
                const completeInput3 = document.getElementById("complete-questionnaire-input-" + connectOfferId + "-3");
                completeInput1.value = postData.answers.answer_1;
                completeInput2.value = postData.answers.answer_2;
                completeInput3.value = postData.answers.answer_3;
                downloadQuestionnaireTable.setAttribute("hidden", "hidden");
            }
            window.console.log(res);
            hideLoading();
            if (res.data.status === 'failed') {
                hideLoading();
                alert("資料DL履歴の保存に失敗しました");
                return;
            }
            else if (res.data.status === 'success') {
                const completeInputId = "webooth-download-complete-checkbox-" + connectOfferId + "-";
                const completeInputs = document.querySelectorAll(`[id^=${completeInputId}]`);
                for (const input of completeInputs) {
                    input.checked = dict[input.dataset.id];
                }
                const downloadMain = document.getElementById("sample-series-webooth-download-main-" + connectOfferId);
                const completeMain = document.getElementById("sample-series-webooth-download-complete-main-" + connectOfferId);
                downloadMain.style.display = "none";
                completeMain.style.display = "block";
            }
        }
        catch (error) {
            hideLoading();
            window.console.error(error);
            alert("資料DL履歴の保存に失敗しました");
            return;
        }
    });
}
